import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import {
  type TableColumnFormatDateTime,
  formatDateTimeCellValue,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import { pipe } from 'fp-ts/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';
import { maybeWrapNonEmptyWithLink } from './helpers/maybeWrapWithLink';

export const renderDateTimeCell = <TRow,>(
  format: TableColumnFormatDateTime<TRow>,
  { row, context, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  let value = getValueFromKeyOfType(row, format.field);
  if (typeof value === 'string') {
    // This should never happen if types are correct, but since we had issues with this
    // multiple times and `date-fns-tz` gives misleading error message "RangeError: Invalid time zone specified: UTC"
    // if a numeric string timestamp is passed, we explicitly handle that situation here.
    stumble(
      `Unexpected string value for date/time field ${format.field.toString()} received from backend.`,
    );
    value = +value;
    if (Number.isNaN(value)) {
      value = null;
    }
  }

  return {
    content: pipe(
      formatDateTimeCellValue(value, context.timezone, format.format),
      maybeWrapNonEmptyWithLink(
        row,
        severity !== null,
        format.createLinkProps,
        !context.disableLinks,
      ),
    ),
  };
};
